import { render } from "./ethetical-forming-relationship.vue?vue&type=template&id=579151e2&scoped=true"
import script from "./ethetical-forming-relationship.vue?vue&type=script&lang=js"
export * from "./ethetical-forming-relationship.vue?vue&type=script&lang=js"

import "./ethetical-forming-relationship.vue?vue&type=style&index=0&id=579151e2&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579151e2"]])

export default __exports__